import { Participant as DolbyParticipant } from '@voxeet/voxeet-web-sdk/types/models/Participant';
import { IParticipant } from '@interfaces/participants';

export default class ParticipantService {
  static getDisplayInitials(participant: IParticipant): string {
    if (participant.initials) return participant.initials;
    const built = ParticipantService.buildInitials(participant.name);
    return built || '?';
  }

  static isParticipantConnected(participant: DolbyParticipant) {
    return (
      ['Decline', 'Error', 'Kicked', 'Left'].indexOf(participant.status) < 0
    );
  }

  static buildInitials(name?: string): string | undefined {
    if (!name) return undefined;

    const words = name.trim().split(/\s+/);
    const letters: string[] = [];

    for (const word of words) {
      const match = word.match(/\p{L}/u);

      if (match) {
        letters.push(match[0].toUpperCase());
        if (letters.length === 2) break;
      }
    }

    return letters.length > 0 ? letters.join('') : undefined;
  }
}
